import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {AthletePropositionBetModuleFetchHandler} from "./athlete-proposition-bet-module.fetch-handler";

export class AthletePropositionBetModuleHandlers extends HandlerList {
  static injectables = [
    AthletePropositionBetModuleFetchHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    athletePropositionBetModuleFetchHandler: AthletePropositionBetModuleFetchHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      athletePropositionBetModuleFetchHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
